import { Component } from '@angular/core';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsMessageComponent
} from "@wms/components";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {DialogService, UserService} from "@wms/services";
import {SessionTimeoutService} from "@wms/app/services/session-timeout/session-timeout.service";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent
  ],
  selector: 'wms-sso-session-timeout',
  templateUrl: './wms-sso-session-timeout.component.html',
  styleUrls: ['./wms-sso-session-timeout.component.less']
})
export class WmsSsoSessionTimeoutComponent extends BaseComponent {
  isLoginInProgress: boolean = false;
  msgData: any = {type: '', show: false, caption: ''};

  constructor(private userService: UserService,
              private sessionTimeoutService: SessionTimeoutService,
              private dialogService: DialogService) {
    super();
  }


  /**
   * sets the message and message type to show on the dialog
   * @param msg
   * @param type
   */
  showMsg(msg: string, type: string) {
    this.msgData = {show: true, caption: msg, type: type};
  }

  login() {
    this.isLoginInProgress = true;
    const loginUrl = location.origin+"/login?target_url="+location.origin+"/s/sso-callback";
    const win = window.open(loginUrl, "SSOLogin");
    window.addEventListener("message", (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data === "sso-login-success") {
        this.isLoginInProgress = false;
        this.sessionTimeoutService.markLoginSuccess();
        this.dialogService.close('ssoSessionTimeoutDialog');
        clearInterval(intervalId);
      }
    });

    const intervalId = setInterval( () => {
      if (win?.closed) {
        this.isLoginInProgress = false;
        clearInterval(intervalId);
      }
    }, 3000);
  }
}
